import { render, staticRenderFns } from "./Changelog.vue?vue&type=template&id=b1d59382&scoped=true&"
import script from "./Changelog.vue?vue&type=script&lang=js&"
export * from "./Changelog.vue?vue&type=script&lang=js&"
import style0 from "./Changelog.vue?vue&type=style&index=0&id=b1d59382&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d59382",
  null
  
)

export default component.exports